import React, { useState } from "react";
import {
  Select,
  Button,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneRestaurant } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import ModalDetails from "../utils/hotelRestauDetails/ModalDetails";
import ExteriorImages from "./exteriorImages";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  DescriptionSection,
} from "../utils/AddSections";
import {
  FiImage,
  FiClock,
  FiDollarSign,
  FiPlus,
  FiSettings,
} from "react-icons/fi";
import { FaUtensils } from "react-icons/fa";

const Add = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const restaurant: any = getOneRestaurant();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const restaurant_id = restaurant?.restaurant_id;
  const [title, setTitle] = useState<any>(restaurant?.name);
  const [thumbnail, setThumbnail] = useState<any>(restaurant?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(restaurant?.image_cdn_id);
  const [openedDays, setOpenedDays] = useState<any>(restaurant?.opened_days);
  const [openedAt, setOpenedAt] = useState<any>(restaurant?.opened_at);
  const [closedAt, setClosedAt] = useState<any>(restaurant?.closed_at);
  const [rating, setRating] = useState<any>(restaurant?.rating);
  const [email, setEmail] = useState<any>(restaurant?.email_address);
  const [payLink, setPayLink] = useState<any>(restaurant?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(restaurant?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(restaurant?.whatsapp);
  const [facebook, setFacebook] = useState<any>(restaurant?.facebook);
  const [twitter, setTwitter] = useState<any>(restaurant?.twitter);
  const [instagram, setInstagram] = useState<any>(restaurant?.instagram);
  const [youtube, setYoutube] = useState<any>(restaurant?.youtube);
  const [hashtags, setHashtags] = useState<any>(restaurant?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(
    restaurant?.google_map_code
  );
  const [latitude, setLatitude] = useState<any>(restaurant?.latitude);
  const [longitude, setLongitude] = useState<any>(restaurant?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    restaurant?.formatted_address
  );
  const [promoted, setPromoted] = useState<any>(
    restaurant?.promoted ? restaurant?.promoted : "no"
  );
  const [restaurantStatus, setRestaurantStatus] = useState<any>(
    restaurant?.status
  );
  const [description, setDescription] = useState<any>(restaurant?.description);
  const [collection, setCollection] = useState<any>(
    restaurant?.HotelRestauDescriptions
      ? restaurant?.HotelRestauDescriptions
      : []
  );
  const [expo, setExpo] = useState<any>(restaurant?.expo);
  const [exteriorImages, setExteriorImages] = useState<any>(
    restaurant?.exterior_images
  );
  const [showExtImages, setShowExtImages] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState<any>(restaurant?.type);
  const [pricing, setPricing] = useState<any>(restaurant?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const [menu, setMenu] = useState<any>(
    restaurant?.RestaurantMenus ? restaurant?.RestaurantMenus?.thumbnail : null
  );
  const [menu_id, setMenuId] = useState<any>(
    restaurant?.RestaurantMenus
      ? restaurant?.RestaurantMenus?.image_cdn_id
      : null
  );

  const restaurantRoutes = "/data/restaurant";

  const responses = (isError: any, msg: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg);
  };

  const updateOneRestaurantHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) responses(true, "Image Required");
    else await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : restaurant?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      name: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      type: type ? type : "african",
      description,
      city_level: "level",
      opened_days: openedDays,
      opened_at: openedAt,
      closed_at: closedAt,
      rating,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      pay_link: payLink,
      whatsapp,
      facebook,
      twitter,
      instagram,
      youtube,
      hashtag: hashtags,
      audio_ad: "none",
      google_map_code: googleMapCode,
      latitude,
      longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: restaurantStatus,
      promoted,
      subdata: collection?.length > 0 ? collection : [],
      menu: menu
        ? {
            name: "...",
            category: "...",
            description: "...",
            thumbnail: menu,
            image_cdn_id: menu_id,
          }
        : null,
      expo,
      exterior_images: exteriorImages?.filter((x: any) => x?.thumbnail !== null),
      pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: restaurant_id,
      data,
      content: _TYPES_.RESTAURANT,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={restaurantRoutes}
      eyebrow="DoSee Data • Restaurants"
      title="Edit Restaurant"
      subtitle={`Update a restaurant in ${entry_label || "this destination"}.`}
      icon={<FaUtensils className="h-5 w-5" />}
      modals={
        <>
          {showDescriptionModal ? (
            <GenerateDescription
              setDescription={setDescription}
              setShowDescriptionModal={setShowDescriptionModal}
            />
          ) : null}
          <ModalDetails
            onClick={() => setShowModal(false)}
            showModal={showModal}
            collection={collection}
            setCollection={setCollection}
          />
          <ExteriorImages
            exteriorImages={exteriorImages}
            setExteriorImages={setExteriorImages}
            showModal={showExtImages}
            onClick={() => setShowExtImages(false)}
          />
        </>
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneRestaurantHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null as any);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Profile Image & Menu"
        hint="Restaurant cover, plus an optional menu PDF/image."
        icon={<FiImage className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <p className="mb-2 text-xs font-semibold text-gray-600">
              Profile Image
            </p>
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder(country_name, FOLDERS.RESTAURANTS)}
            />
          </div>
          <div>
            <p className="mb-2 text-xs font-semibold text-gray-600">Menu</p>
            <ImageKitUpload
              thumbnail={menu}
              thumbnailId={menu_id}
              setThumbnail={setMenu}
              setThumbnailId={setMenuId}
              folder={image_kit_folder(country_name, FOLDERS.RESTAURANTS)}
            />
          </div>
        </div>
      </AddSection>

      <AddSection title="Restaurant Details" hint="Name, cuisine type and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "type",
              title: "Cuisine Type",
              type: "text",
              preselect: type ? [{ name: type }] : null,
              option: [
                "african",
                "american",
                "south american",
                "european",
                "asian",
                "oceanian",
                "intercontinental",
              ],
              onChange: (e: any) => {
                setType(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Hours"
        hint="Operating days and hours."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            props={{
              id: "opened_days",
              title: "Open Days",
              type: "text",
              value: openedDays || "",
              onChange: (e: any) => {
                setOpenedDays(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "opened_at",
              title: "Opened At",
              type: "time",
              value: openedAt || "",
              onChange: (e: any) => {
                setOpenedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "closed_at",
              title: "Closed At",
              type: "time",
              value: closedAt || "",
              onChange: (e: any) => {
                setClosedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "rating",
              title: "Rating",
              type: "text",
              value: rating || "",
              onChange: (e: any) => {
                setRating(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <AddSection
        title="Visibility"
        hint="Where this entry appears across the site."
        icon={<FiSettings className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <Select
            props={{
              id: "restaurant_status",
              title: "Status",
              option: ["visible", "invisible"],
              preselect:
                restaurantStatus !== null && restaurantStatus !== undefined
                  ? [
                      {
                        name: restaurantStatus === 1 ? "visible" : "invisible",
                      },
                    ]
                  : null,
              onChange: (e: any) => {
                if (e.target.selectedIndex === 0) setRestaurantStatus(1);
                else setRestaurantStatus(0);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "promoted",
              title: "Promoted",
              option: ["no", "yes"],
              preselect:
                promoted !== null && promoted !== undefined
                  ? [{ name: promoted }]
                  : null,
              onChange: (e: any) => {
                setPromoted(e.target.value);
                clearMessages();
              },
            }}
          />
          <Select
            props={{
              id: "gallery",
              title: "Show in Gallery",
              option: ["no", "yes"],
              preselect:
                expo !== null && expo !== undefined
                  ? [{ name: expo === 0 ? "no" : "yes" }]
                  : null,
              onChange: (e: any) => {
                const choice = e.target.value;
                setExpo(choice === "no" ? 0 : 1);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Galleries & Extras"
        hint="Optional interior/exterior photos and menu items."
        icon={<FiPlus className="h-4 w-4" />}
      >
        <div className="flex flex-wrap items-center gap-3">
          <Button
            props={{
              type: "button",
              title: "Change Inter. / Exter. Images",
              category: "default",
              action: "edit",
              onClick: () => setShowExtImages(true),
            }}
          />
          <Button
            props={{
              type: "button",
              title: "Change More Details",
              category: "default",
              action: "edit",
              onClick: () => setShowModal(true),
            }}
          />
        </div>
      </AddSection>

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Add;
